import React from 'react';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetRowViewModel} from "../../models/standings-widget.row-view-model";
import {StandingsWidgetTableStatsCells} from "./standings-widget.table.stats-cells";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {StandingsWidgetCompetitorName} from "../competitor/standings-widget.competitor.name";
import {StandingsWidgetCompetitorBadge} from "../competitor/standings-widget.competitor-badge";
import {ScrollableTableRow} from "../../../../core/components/scrollable-table/scrollable-table-row";
import {ScrollableTableCell} from "../../../../core/components/scrollable-table/scrollable-table-cell";

export class StandingsWidgetTableRowProps extends BaseProps {
  row: StandingsWidgetRowViewModel;
  controller: StandingsWidgetController;
  source: String;
}

export const StandingsWidgetTableRow = observer(({
                                                   row,
                                                   source,
                                                   controller,
                                                   firstCellWidth
                                                 }: StandingsWidgetTableRowProps) => {
  const {state} = controller;
  const {isHighlighted} = row;
  const {isCollapsed, hoveredCompetitorIds, noHoverCompetitorsIds} = state;

  const isHighlightedCompetitor: Boolean = !isCollapsed && isHighlighted && noHoverCompetitorsIds;
  const isHoveredCompetitorIds: Boolean = hoveredCompetitorIds.includes(row.competitor.id);

  const containerProps = {
    className: classNames(
      styles.table_row,
      {[styles.table_row_highlighted_darker]: isHighlightedCompetitor},
      {[styles.table_row_highlighted_darker]: isHoveredCompetitorIds},
      styles.table_row_border,
    )
  }

  const cellsProps = {
    controller,
    source,
    firstCellWidth,
    row
  }

  return (
    <ScrollableTableRow {...containerProps}>
      <ScrollableTableCell className={classNames({[styles.table_row_highlighted_darker]: isHighlightedCompetitor},
        {[styles.table_row_highlighted_darker]: isHoveredCompetitorIds})}>
        <StandingsWidgetCompetitorBadge {...cellsProps}/>
      </ScrollableTableCell>
      <StandingsWidgetCompetitorName {...cellsProps}/>
      <StandingsWidgetTableStatsCells {...cellsProps}/>
    </ScrollableTableRow>
  )
});
